<script setup lang="ts">
import {
  EducationOfferingItemFieldsFragment,
  LatestEducationOfferingsFieldsFragment,
  MediaImageFragment,
  ParagraphLatestEducationOfferings,
} from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphLatestEducationOfferings
}>()

const offers = props.entity.fieldItems?.map((offer) => {
  const data = offer?.entity as LatestEducationOfferingsFieldsFragment

  return {
    title: data.fieldTitle || '',
    tabItems: data.fieldItems?.map((tabItem) => {
      const item = tabItem?.entity as EducationOfferingItemFieldsFragment

      return {
        title: item.fieldTitle ?? '',
        subtitle: item.fieldEducationType ?? '',
        description: item.fieldEducationLocation ?? '',
        link: {
          url: item.fieldLink?.url?.path ?? '',
          target: item.fieldLink?.options.attributes.target ?? '_self',
        },
      }
    }),
  }
})
</script>

<template>
  <SectionSpecial :title="entity?.fieldTitle || ''" :sub-title="entity?.fieldDescription?.processed || ''">
    <Tabs v-if="offers">
      <template #headers>
        <TabHeader
          v-for="(tab, index) of offers"
          :key="index"
          v-animate="{ animation: 'vertical-reveal' }"
          :index="index"
          :title="tab.title"
        />
      </template>

      <Tab v-for="(tab, i) of offers" :key="i" :index="i">
        <LinkListLarge>
          <template #default="{ isHovered }">
            <LinkListLargeItemEducationalOffering
              v-for="(item, j) of tab.tabItems"
              :key="j"
              v-animate="{ animation: 'vertical-reveal' }"
              :title="item.title"
              :subtitle="item.subtitle"
              :description="item.description"
              :link="item.link"
              :dim="isHovered"
            />
          </template>
        </LinkListLarge>
      </Tab>
    </Tabs>
  </SectionSpecial>
</template>
<style scoped lang="scss"></style>
